export const dotStyle = {
    display: 'inline-block',
    width: '8px',
    height: '8px',
    margin: '0 2px',
    borderRadius: '50%',
    backgroundColor: '#fff',
    animation: 'dot-blink 0.5s infinite both',
  };
  
  export const dotContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: "10px 30px",
  };

  export const headCellStyle = {
    color:"white",
    fontWeight:'bold',
  }